import {isAccessability, initScrollTheadTable, showHideThead} from './scroll_thead_table';
import {rebuildBlocks} from './helpers';
import {sigTooltipHandler} from './file_signatures';
import {initHotLineIfNeed} from './hotline';

$_vikon(() => {
    const body = $_vikon('body');
    const vw = $_vikon('.vikon-wrapper');

    rebuildBlocks();
    $_vikon('#abitur-hrefs')
        .on('click', '.block-main-page', function () {
            const hash = $_vikon(this).data('block-hash');
            const blockName = $_vikon(this).data('block-name');
            const content = body.find(`[id=${hash}]`).html();
            const hideEye = ($_vikon(this).parents('.vikon-portable').length == 1);
            showAbiturModal(vw, content, hash, blockName, hideEye);
        })
        .on('click', '.abitur-href-itemprop', function () {
            const href = $_vikon(this).data('href');
            if (href) {
                const title = $_vikon(this).text();
                const content = body.find(`[itemprop=${href}]`).html();
                const hideEye = ($_vikon(this).parents('.vikon-portable').length == 1);
                showAbiturModal(vw, content, href, title, hideEye);
            } else {
                console.log('Нет входных параметров');
            }
        })
        .on('click', '.abitur-href-id', function () {
            const href = $_vikon(this).data('href');
            if (href) {
                const title = $_vikon(this).text();
                const content = body.find(`[id=${href}]`).html();
                const hideEye = ($_vikon(this).parents('.vikon-portable').length == 1);
                showAbiturModal(vw, content, href, title, hideEye);
            } else {
                console.log('Нет входных параметров');
            }
        });
});

function showAbiturModal(layaout, content, href, title = '', hideEye = false) {
    window.history.pushState({}, '', `#abitur_${href}`);

    const eye = '<button type="button" class="abitur-modal-btn accessability" aria-label="Close">'
        + '<span class="glyphicon glyphicon-eye-open"></span>'
        + '</button>';

    const container = $_vikon(`<div class="button-close-container${
        sessionStorage.getItem('accessability') === '1' ? ' button-close-container-margin-top' : ''}">`
            + '<button type="button" class="abitur-modal-btn close-modal" aria-label="Close">'
            + '<span class="glyphicon glyphicon-remove"></span>'
            + `</button>${
                !hideEye ? eye : ''
            }</div>`
            + '<div class="button-return-container">'
            + '<button type="button" class="abitur-modal-btn return" aria-label="Return">'
            + '<span aria-hidden="true">Назад</span>'
            + '</button>'
            + '</div>'
            + '<div class="abitur-modal vikon-content" id="vikon-content-abitur">'
            + '<div class="abitur-modal-content container-abitur">'
            + `<div class="text-center"><h1>${title}</h1></div>`
            + `<div>${
                content
            }</div>`
            + '</div>'
            + '</div>');
    layaout.prepend(container);
    $_vikon('body').css({
        overflow: 'hidden',
    });
    container
        .on('click', '.close-modal, .return, .button-return-container', () => {
            window.history.pushState({}, '', '#');
            container.remove();
            $_vikon('body').css({
                overflow: 'visible',
            });
            initScrollTheadTable();
        })
        .scroll(() => {
            if (!isAccessability()) {
                showHideThead();
            }
        });
    container.find('.tooltip-sig').tooltip({
        html: true,
        title: sigTooltipHandler,
        placement: 'auto',
    });
    initScrollTheadTable();
    initHotLineIfNeed(container);
}